import HTTP from "../HTTP";
import Jsona from "jsona";

const dataFormatter = new Jsona();

export default {
  async create(payload) {
    try {
      let data = {
        data: {
          type: "bank_accounts",
          attributes: payload.bank_account,
          relationships: {
            payment_gateway_account: {
              data: {
                type: "payment_gateway_accounts",
                id: payload.payment_gateway_account_id
              }
            }
          }
        }
      }

      let bank_account = await HTTP.normal.post("/bank-accounts", data);
      return dataFormatter.deserialize(bank_account.data);
    } catch (e) {
      var error = [];

      e.response.data.forEach(el => {
        if (el.title === "has already been taken") {
          error.push({
            field: el.detail.split(" ")[0],
            msg: "já está sendo usado"
          });
        }
      });

      throw error;
    }
  },

  async update(payload) {
    try {
      let data = {
        data: {
          id: payload.bank_account_id,
          type: "bank_accounts",
          attributes: payload.bank_account,
          relationships: {
            payment_gateway_account: {
              data: {
                type: "payment_gateway_accounts",
                id: payload.payment_gateway_account_id
              }
            }
          }
        }
      }

      let bank_account = await HTTP.normal.patch(`/bank-accounts/${payload.bank_account_id}`, data);
      return dataFormatter.deserialize(bank_account.data);
    } catch (e) {
      var error = [];

      e.response.data.forEach(el => {
        if (el.title === "has already been taken") {
          error.push({
            field: el.detail.split(" ")[0],
            msg: "já está sendo usado"
          });
        }
      });

      throw error;
    }
  }
};



// WEBPACK FOOTER //
// ./src/API/modules/bankAccounts.js